import { ProductViewTypes } from "@temp/components/ProductView/types";
import box from "images/box.svg";
import crop from "images/crop.svg";
import sidebar from "images/sidebar.svg";
import React, { useCallback } from "react";
import ReactSVG from "react-svg";
import * as S from "./styles";
export var ProductViewsTabs = function ProductViewsTabs(_ref) {
  var isMobile = _ref.isMobile,
      openMobileInfoPopup = _ref.openMobileInfoPopup,
      view = _ref.view,
      setView = _ref.setView;
  return React.createElement(React.Fragment, null, React.createElement(S.Wrapper, null, React.createElement(S.Button, {
    className: "product-view__3d-view",
    onClick: useCallback(function () {
      setView(ProductViewTypes["3d"]);
    }, [setView]),
    active: view === ProductViewTypes["3d"]
  }, React.createElement(ReactSVG, {
    path: box
  })), React.createElement(S.Button, {
    className: "product-view__dimension-view",
    onClick: useCallback(function () {
      if (isMobile) {
        openMobileInfoPopup();
        return;
      }

      setView(ProductViewTypes.Dimension);
    }, [setView, isMobile, openMobileInfoPopup]),
    active: view === ProductViewTypes.Dimension
  }, React.createElement(ReactSVG, {
    path: crop
  })), React.createElement(S.Button, {
    className: "product-view__side-view",
    onClick: useCallback(function () {
      if (isMobile) {
        openMobileInfoPopup();
        return;
      }

      setView(ProductViewTypes.Side);
    }, [setView, isMobile, openMobileInfoPopup]),
    active: view === ProductViewTypes.Side
  }, React.createElement(ReactSVG, {
    path: sidebar
  }))));
};